import type React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../utils/utils";

type TextElement =
	| "p"
	| "div"
	| "span"
	| "li"
	| "h1"
	| "h2"
	| "h3"
	| "h4"
	| "h5"
	| "h6";

const textVariants = cva("", {
	variants: {
		variant: {
			title: "text-base font-medium",
			tile: "text-lg font-light",
			tag: "text-xs font-bold",
			articleTitle1: "text-2xl font-medium",
			articleTitle2: "text-lg font-medium",
			link: "text-xs font-bold",
			title2: "text-xl font-bold",
			text1: "text-base",
			text2: "text-sm",
			text3: "text-xs",
			button: "text-sm font-bold",
			list: "text-xl",
		},
	},
	defaultVariants: {
		variant: "text1",
	},
});

interface TextFragmentProps {
	as: TextElement;
	variant: "title" | "tile" | "tag" | "articleTitle1" | "articleTitle2" | "link" | "title2" | "text1" | "text2" | "text3" | "button" | "list";
	className?: string;
	children: React.ReactNode;
	onClick?: () => void;
}

const TextFragment: React.FC<TextFragmentProps> = ({
	as: Element,
	variant = "text1",
	className = "",
	children,
	onClick,
}) => {
	return (
		<Element className={cn(textVariants({ variant }), className)} onClick={onClick}>
			{children}
		</Element>
	);
};

export default TextFragment;
